import { memo } from 'react';

import { formatNumberWithCommas } from '@/utils/FormatNumber';
import { cn } from 'lib/utils';

export type AllowedColors =
  | 'fuchsia'
  | 'blue'
  | 'green'
  | 'red'
  | 'gray'
  | 'yellow'
  | 'indigo'
  | 'no-color';

type StyledCellProps = {
  value: number | string;
  color?: AllowedColors;
  comma?: number;
  className?: string; // Allows additional Tailwind classes
};

function StyledCellColumnComponent({
  value,
  comma = 0,
  color = 'fuchsia',
  className = '',
}: StyledCellProps) {
  // If "no-color" is chosen, don't add any dynamic color classes.
  const dynamicClasses =
    color !== 'no-color'
      ? `bg-${color}-200/30 text-${color}-800 dark:bg-background dark:text-${color}-50 `
      : '';

  // Pre-compute the value formatting
  const formattedValue =
    typeof value === 'number'
      ? formatNumberWithCommas(value, comma)
      : value || '-';

  return (
    <div
      className={cn(
        'm-1 flex h-8 items-center justify-center rounded font-roboto text-sm font-bold',
        dynamicClasses,
        className,
      )}
    >
      {formattedValue}
    </div>
  );
}

// Memoize the component to prevent unnecessary re-renders
export const StyledCellColumn = memo(StyledCellColumnComponent);
